import { PAYMENT_CARD_YEARS_LIMIT_DEFAULT } from '@constants/app.constants';
import { DateTime } from 'luxon';

export const isDateSameDay = (date1: DateTime, date2: DateTime) => {
  return (
    date1.day === date2.day &&
    date1.month === date2.month &&
    date1.year === date2.year
  );
};

export const isDateSameMonth = (date1: DateTime, date2: DateTime) => {
  return date1.month === date2.month && date1.year === date2.year;
};

export const isDateSameYear = (date1: DateTime, date2: DateTime) => {
  return date1.year === date2.year;
};

export const isDateSameMonthAndYear = (date1: DateTime, date2: DateTime) => {
  return isDateSameMonth(date1, date2) && isDateSameYear(date1, date2);
};

export const isDateBefore = (date1: DateTime, date2: DateTime) => {
  return date1.toMillis() < date2.toMillis();
};

export const isDateAfter = (date1: DateTime, date2: DateTime) => {
  return date1.toMillis() > date2.toMillis();
};

export const isDateBetween = (
  DateTime: DateTime,
  startDate: DateTime,
  endDate: DateTime,
) => {
  return isDateAfter(DateTime, startDate) && isDateBefore(DateTime, endDate);
};

export const addDateYears = (DateTime: DateTime, years: number) => {
  return DateTime.plus({ years });
};

export const addDateMonths = (DateTime: DateTime, months: number) => {
  return DateTime.plus({ months });
};

export const addDateDays = (DateTime: DateTime, days: number) => {
  return DateTime.plus({ days });
};

export const daysInMonthFromDate = (DateTime: DateTime) => {
  return DateTime.daysInMonth || 31;
};

export const indexOfFirstDayInMonthOfYear = (year: number, month: number) => {
  return DateTime.local(year, month, 1).weekday - 1;
};

export const substractDateMonths = (DateTime: DateTime, months: number) => {
  return DateTime.minus({ months });
};

export const substractDateDays = (DateTime: DateTime, days: number) => {
  return DateTime.minus({ days });
};

export const eachDayOfInterval = (
  start: DateTime<true> | DateTime<false> | undefined,
  end: DateTime<true> | DateTime<false> | undefined,
) => {
  if (!start || !end) {
    return [];
  }
  const days: DateTime[] = [];
  let current = start;
  while (current <= end) {
    days.push(current);
    current = addDateDays(current, 1);
  }
  return days;
};

export const getYearsFromNowByCount = (
  count: number = PAYMENT_CARD_YEARS_LIMIT_DEFAULT,
) => {
  const currentYear = DateTime.now().year;
  const years: number[] = [];
  for (let i = 0; i < count; i++) {
    years.push(currentYear + i);
  }
  return years;
};
